import React, { Component } from 'react';
import styled from 'styled-components';
import { connectDeep } from 'redux-utils';
import App from 'models/app';
import ContentGrid from 'components/v2/AppContentGrid/ContentGrid';
import ItemGrid from 'components/v2/AppContentGrid/ItemGrid';
import HomeContainer from 'components/v2/HomeContainer';
import { Transition } from 'components/v2/Transition';
import { ScrollContainer } from 'components/v2/ScrollContainer';
import i18n from 'i18n';
import { ButtonLink } from '../../components/v2/Button/index';
import { RoutePaths } from '../../constants';

const AppIcon = styled.img`
  width: 100%;
  max-width: 110px;
  height: auto;
  aspect-ratio: 1 / 1;
  border-radius: 16px;
  object-fit: contain;
  margin-bottom: 12px;
`;

const Container = styled.div`
  height: calc(100vh - 64px);
  overflow-y: auto;
  background: var(--sys-color--surface);
  display: flex;
  flex-direction: column;
`;

const BottomFixedBar = styled.div`
  margin-top: auto;
  width: 100%;
  box-sizing: border-box;
  padding: 16px 32px;
  background: var(--sys-color--surface);
  display: flex;
  justify-content: center;

  @media (min-width: 321px) {
    padding: 16px;
  }
`;

const StyledLinkContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  text-decoration: none;

  a {
    width: 100%;
  }
`;


const mapStateToProps = (state: any) => {
  const { registry } = state;
  const {
    installed: { loading: installedLoading, error, entries = [] },
    features: { loading: featuresLoading },
  } = registry;

  const installedApps = [];
  for (const { appId } of entries) {
    const app = App.selectFromState(appId, state);
    if (app && app.isInstalledOrInstalling && !app.isClock) {
      installedApps.push(app);
    }
  }

  return {
    loading: (installedLoading && entries.length === 0) || featuresLoading,
    error,
    installedApps,
  };
};

class InstalledAppsPage extends Component<any> {
  renderBody() {
    const { installedApps } = this.props;

    return (
      <ScrollContainer scrollKey="installedAppsPage" navbarHeight={64}>
        <Container>
          <ContentGrid>
            {installedApps.map((app: any) => (
              <ItemGrid
                key={app.id}
                id={app.id}
                title={app.name}
                linkTo={`/v2/app/${app.id}`}
                photo={<AppIcon src={app.icon?.uri || ''} alt={app.name} />}
              />
            ))}
          </ContentGrid>
          <BottomFixedBar>
            <StyledLinkContainer>
              <ButtonLink to="/v2/apps/discover" pageDirection="FORWARD" variant="filled" fullWidth>
                {i18n('page.AppGallery.listPageName')()}
              </ButtonLink>
            </StyledLinkContainer>
          </BottomFixedBar>
        </Container>
      </ScrollContainer>
    );
  }

  render() {
    const { loading, error } = this.props;

    return (
      <HomeContainer selected={RoutePaths.GALLERY_APPS} centerTitle="Apps">
        {loading || error ? (
          <Transition loading={loading} error={error} headerHeight={64} />
        ) : (
          this.renderBody()
        )}
      </HomeContainer>
    );
  }
}

export default connectDeep(mapStateToProps)(InstalledAppsPage);
